export default __webpack_public_path__ + "static/media/Frame.cc3be387.svg";